import { PROCESSING_OPTIONS_KEYS } from '_constants/processing';
import { PRODUCT_CODES } from '_constants/products';
import { STORAGE_KEYS } from '_constants/storage';
import { restoreLocalValue } from '_helpers/storage';

export const createUpsellBody = (form = {}, orderAfterPayment) => {
  const products = [];

  const { individual, markDesc: trademarkName } =
    orderAfterPayment?.products.find(
      ({ code }) => code?.code === PRODUCT_CODES.tmRegisterTrademark
    ) || {};

  const trademarkOwner = {
    firstName: individual?.firstName,
    lastName: individual?.lastName,
    email: individual?.email,
    phone: individual?.phone,
  };

  if (form.isOfficeAction) {
    products.push({
      code: PRODUCT_CODES.tmOfficeActionResponse,
      trademarkName,
      trademarkOwner,
    });
  }

  if (form.isKeepAlive) {
    products.push({
      code: PRODUCT_CODES.tmKeepTrademarkAlive,
      trademarkName,
      trademarkOwner,
    });
  }

  if (form.isCertifiedCopy) {
    products.push({
      code: PRODUCT_CODES.tmCertifiedCopy,
      trademarkName,
      trademarkOwner,
    });
  }

  if (form.privacyPackage !== 'NONE') {
    products.push({
      code: form.privacyPackage,
      trademarkName,
      trademarkOwner,
    });
  }

  if (form.trademarkAssessment) {
    products.push({
      code: PRODUCT_CODES.tmLegalTeamTrademarkAssessment,
      trademarkName,
      trademarkOwner,
    });
  }

  return {
    order: {
      processingOption: PROCESSING_OPTIONS_KEYS.upsell,
    },
    products,
  };
};

export const fillUpsellBodyWithSourceData = (upsellBody) => {
  if (restoreLocalValue(STORAGE_KEYS.gclid)) {
    upsellBody.order.clid = restoreLocalValue(STORAGE_KEYS.gclid);
  }

  if (restoreLocalValue(STORAGE_KEYS.source)) {
    upsellBody.order.source = restoreLocalValue(STORAGE_KEYS.source);
  }

  if (restoreLocalValue(STORAGE_KEYS.keyword)) {
    upsellBody.order.keyword = restoreLocalValue(STORAGE_KEYS.keyword);
  }

  if (restoreLocalValue(STORAGE_KEYS.adAccount)) {
    upsellBody.order.adAccount = restoreLocalValue(STORAGE_KEYS.adAccount);
  }
};
